import { FunctionComponent } from 'react';

import { LoadingSpinner, Text } from '@kanda-libs/ks-design-library';

const OpenBankingSatNoteFormLoader: FunctionComponent = () => (
  <div className="flex-col w-full mb-6">
    <Text
      className="block mb-8 text-2xl text-20-24-em text-center"
      text="Loading Satisfaction Note"
    />
    <LoadingSpinner stroke="purple-300" className="mx-auto mt-10" />
  </div>
);

export default OpenBankingSatNoteFormLoader;
